import React from "react";

export * from "./InventoryControl/InventoryControl";

// export { default as FreezeTable } from "./Table/FreezeTable/FreezeTable";
// export { default as FreezeTableClient } from "./Table/FreezeTable/FreezeTableClient";

export const FreezeTable = React.lazy(() =>
  import("./Table/FreezeTable/FreezeTable")
);

export const FreezeTableClient = React.lazy(() =>
  import("./Table/FreezeTable/FreezeTableClient")
);

export const LoadingTableSkeleton = React.lazy(() =>
  import("./Loading/LoadingTableSkeleton")
);

export const LoadingTableEmpty = React.lazy(() =>
  import("./Loading/LoadingTableEmpty")
);
